import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import CustomFieldsForm from 'js/components/Form/CustomFields/CustomFieldsForm'
import FormItem from 'js/components/Form/FormItem'
import IconButton from 'js/components/IconButton/IconButton'

import SettingsIcon from 'icons/settings-small.svg'

const AttendanceForm = () => {
    const { t } = useTranslation()

    const [showSettingsModal, setShowSettingsModal] = useState(false)

    const { control, getValues, setValue } = useFormContext()

    const defaultValues = {
        title: getValues('form.title'),
        description: getValues('form.description'),
        formFields: getValues('form.formFields'),
    }

    const onSubmit = ({ title, description, formFields }) => {
        const form = {
            title,
            description,
            formFields: formFields?.map(
                ({
                    guid,
                    title,
                    description,
                    fieldType,
                    isMandatory,
                    fieldOptions,
                }) => ({
                    guid,
                    title,
                    description,
                    fieldType,
                    isMandatory,
                    fieldOptions: fieldOptions.filter((option) => option), // Filter out empty values
                }),
            ),
        }
        setValue('form', form)
        setValue('isFormEnabled', formFields?.length > 0)
        setShowSettingsModal(false)
    }

    return (
        <>
            <FormItem
                control={control}
                type="switch"
                prependField
                name="isFormEnabled"
                size="small"
                title={t('entity-event.attendance-form')}
                titleAppend={
                    <IconButton
                        size="small"
                        variant="secondary"
                        style={{
                            marginLeft: '2px',
                        }}
                        onClick={() => setShowSettingsModal(true)}
                    >
                        <SettingsIcon />
                    </IconButton>
                }
                helper={t('entity-event.attendance-form-helper')}
            />
            <CustomFieldsForm
                title={t('entity-event.attendance-form')}
                showSettingsModal={showSettingsModal}
                setShowSettingsModal={setShowSettingsModal}
                defaultValues={defaultValues}
                onSubmit={onSubmit}
                fieldTitle={t('form.title')}
                fieldDescription={t('form.description')}
                enableEditOptions
            />
        </>
    )
}

export default AttendanceForm
